module.exports = __webpack_public_path__ + "img/15.8e81d845.png";